import React, {Component} from 'react'

import {GalleryStyle} from './../styles'

export default class Gallery extends Component{
  state = {
    open: false,
    active: null,
    link: null,
    title: '',
    legend: '',
    transition: false,
  }

  handleClick = (index, item) => (e) => {
    e.preventDefault()
    this.setState({
      active: index,
      link: item.image,
      title: item.title,
      legend: item.legend,
      open: true,
    })

    this.timer = setTimeout(() => {
      this.setState({
        transition: true,
      })
    }, 400)
  }

  close = (e) => {
    e.preventDefault()
    this.setState({
      transition: false,
    })

    this.timer = setTimeout(() => {
      this.setState({
        open: false,
      })
    }, 300)

    this.timer = setTimeout(() => {
      this.setState({
        active: null,
        link: null,
        title: '',
        legend: '',
      })
    }, 700)
  }

  render () {
    const {images} = this.props
    const {active, open, link, title, transition, legend} = this.state
    return(
      <div className={`${GalleryStyle(open, transition)} gallery`}>
        <div className="flex gallery__pictures">
          { images.map((item, index) => (
            <div className={`picture gallery__picture ${index === active ? 'active' : null}`} key={index} onClick={this.handleClick(index, item)}>
              <img src={item.image} alt={item.title} />
            </div>
          ))}
        </div>

            <div className="gallery__focus">
              <button className="gallery__close" onClick={this.close}></button>
              {link && (
                <div>
                  <img src={link} alt={title} />
                  <p className="gallery__focus-legend">{
                    legend
                  }</p>
                </div>
              )}
            </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Gallery.js